import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dialog-page" }
const _hoisted_2 = { class: "app-dialog" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cucc = _resolveComponent("Cucc")!
  const _component_Cmcc = _resolveComponent("Cmcc")!

  return (_openBlock(), _createBlock(_Transition, { name: "up" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "space",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickOuter && _ctx.clickOuter(...args)))
          }),
          (_ctx.showCucc)
            ? (_openBlock(), _createBlock(_component_Cucc, {
                key: 0,
                type: _ctx.type,
                onOnClose: _ctx.onCuccClose
              }, null, 8, ["type", "onOnClose"]))
            : _createCommentVNode("", true),
          (_ctx.showCmcc)
            ? (_openBlock(), _createBlock(_component_Cmcc, {
                key: 1,
                type: _ctx.type,
                onOnClose: _ctx.onCuccClose
              }, null, 8, ["type", "onOnClose"]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.show]
        ])
      ])
    ]),
    _: 1
  }))
}